export const PinIcon = ({ className }: { className?: string }) => (
    <svg name="Pin" className={className} width="16" height="16" viewBox="0 0 26 26">
        <path
            fill="currentColor"
            d="M22 12L12.101 2.10101L10.686 3.51401L12.101 4.92901L7.15096 9.87801V9.88001L5.73596 8.46501L4.32196 9.88001L8.56496 14.122L2.90796 19.778L4.32196 21.192L9.97896 15.536L14.222 19.778L15.636 18.364L14.222 16.95L19.171 12H19.172L20.586 13.414L22 12Z"
        />
    </svg>
);
